/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { LogPaginated } from '../model';
// @ts-ignore
import type { Notification } from '../model';
// @ts-ignore
import type { NotificationBulkUpdate } from '../model';
// @ts-ignore
import type { NotificationChannel } from '../model';
// @ts-ignore
import type { NotificationChannelResponse } from '../model';
// @ts-ignore
import type { NotificationPreferenceResponse } from '../model';
// @ts-ignore
import type { NotificationStatus } from '../model';
// @ts-ignore
import type { NotificationTypeMandatoryUpdate } from '../model';
// @ts-ignore
import type { NotificationTypeResponse } from '../model';
// @ts-ignore
import type { NotificationUpdate } from '../model';
// @ts-ignore
import type { PaginatedResultNotification } from '../model';
// @ts-ignore
import type { UpdateNotificationChannelRequest } from '../model';
// @ts-ignore
import type { UpdateNotificationPreferencesRequest } from '../model';
// @ts-ignore
import type { UpdateNotificationTypeMandatoryRequest } from '../model';
// @ts-ignore
import type { UserNotificationPreferenceResponse } from '../model';
/**
 * NotificationsApi - axios parameter creator
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update notifications in bulk.
         * @summary Bulk Update Notification
         * @param {NotificationBulkUpdate} notificationBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateNotification: async (notificationBulkUpdate: NotificationBulkUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationBulkUpdate' is not null or undefined
            assertParamExists('bulkUpdateNotification', 'notificationBulkUpdate', notificationBulkUpdate)
            const localVarPath = `/notifications/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationBulkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Update Current User Notification Preferences
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateNotificationPreferences: async (updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotificationPreferencesRequest' is not null or undefined
            assertParamExists('bulkUpdateNotificationPreferences', 'updateNotificationPreferencesRequest', updateNotificationPreferencesRequest)
            const localVarPath = `/notifications/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationPreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the mandatory flag for several notification types at once (platform super-admin action).  Each entry addresses a catalog row by its id because a tag now maps to several ``(tag, concept)`` rows.
         * @summary Bulk Update Notification Type Mandatory Flags
         * @param {Array<UpdateNotificationTypeMandatoryRequest>} updateNotificationTypeMandatoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateNotificationTypes: async (updateNotificationTypeMandatoryRequest: Array<UpdateNotificationTypeMandatoryRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotificationTypeMandatoryRequest' is not null or undefined
            assertParamExists('bulkUpdateNotificationTypes', 'updateNotificationTypeMandatoryRequest', updateNotificationTypeMandatoryRequest)
            const localVarPath = `/notifications/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationTypeMandatoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single notification owned by the current user.
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getNotification', 'notificationId', notificationId)
            const localVarPath = `/notifications/{notification_id}`
                .replace('{notification_id}', encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated audit logs of notification-settings changes for the caller\'s organization.
         * @summary Get Notification Settings Logs
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationLogs: async (page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Current User Notification Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Current User Notification Preferences (Expanded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferencesExpanded: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/preferences/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all notification types with their category and effective mandatory state.
         * @summary Get Notification Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Notifications
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortDir] 
         * @param {NotificationStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (page?: number, size?: number, sortBy?: string | null, sortDir?: string | null, status?: NotificationStatus | null, name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sort_dir'] = sortDir;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List notification delivery channels and their enabled state for the caller\'s organization.
         * @summary Get Supported Notification Channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedChannels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a single notification.
         * @summary Update Notification
         * @param {string} notificationId 
         * @param {NotificationUpdate} notificationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification: async (notificationId: string, notificationUpdate: NotificationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('updateNotification', 'notificationId', notificationId)
            // verify required parameter 'notificationUpdate' is not null or undefined
            assertParamExists('updateNotification', 'notificationUpdate', notificationUpdate)
            const localVarPath = `/notifications/{notification_id}`
                .replace('{notification_id}', encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set whether a single notification type is mandatory (platform super-admin action).
         * @summary Update Notification Type Mandatory Flag
         * @param {string} notificationTypeId 
         * @param {NotificationTypeMandatoryUpdate} notificationTypeMandatoryUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationType: async (notificationTypeId: string, notificationTypeMandatoryUpdate: NotificationTypeMandatoryUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationTypeId' is not null or undefined
            assertParamExists('updateNotificationType', 'notificationTypeId', notificationTypeId)
            // verify required parameter 'notificationTypeMandatoryUpdate' is not null or undefined
            assertParamExists('updateNotificationType', 'notificationTypeMandatoryUpdate', notificationTypeMandatoryUpdate)
            const localVarPath = `/notifications/types/{notification_type_id}`
                .replace('{notification_type_id}', encodeURIComponent(String(notificationTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationTypeMandatoryUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable/disable a configurable notification channel for the current user\'s organization.
         * @summary Update Supported Notification Channel
         * @param {NotificationChannel} notificationChannel 
         * @param {UpdateNotificationChannelRequest} updateNotificationChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportedChannel: async (notificationChannel: NotificationChannel, updateNotificationChannelRequest: UpdateNotificationChannelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationChannel' is not null or undefined
            assertParamExists('updateSupportedChannel', 'notificationChannel', notificationChannel)
            // verify required parameter 'updateNotificationChannelRequest' is not null or undefined
            assertParamExists('updateSupportedChannel', 'updateNotificationChannelRequest', updateNotificationChannelRequest)
            const localVarPath = `/notifications/channels/{notification_channel}`
                .replace('{notification_channel}', encodeURIComponent(String(notificationChannel)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationChannelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Update notifications in bulk.
         * @summary Bulk Update Notification
         * @param {NotificationBulkUpdate} notificationBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateNotification(notificationBulkUpdate: NotificationBulkUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateNotification(notificationBulkUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.bulkUpdateNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Update Current User Notification Preferences
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateNotificationPreferences(updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserNotificationPreferenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateNotificationPreferences(updateNotificationPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.bulkUpdateNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the mandatory flag for several notification types at once (platform super-admin action).  Each entry addresses a catalog row by its id because a tag now maps to several ``(tag, concept)`` rows.
         * @summary Bulk Update Notification Type Mandatory Flags
         * @param {Array<UpdateNotificationTypeMandatoryRequest>} updateNotificationTypeMandatoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateNotificationTypes(updateNotificationTypeMandatoryRequest: Array<UpdateNotificationTypeMandatoryRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateNotificationTypes(updateNotificationTypeMandatoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.bulkUpdateNotificationTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single notification owned by the current user.
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotification(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated audit logs of notification-settings changes for the caller\'s organization.
         * @summary Get Notification Settings Logs
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationLogs(page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationLogs(page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotificationLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Current User Notification Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationPreferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserNotificationPreferenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationPreferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Current User Notification Preferences (Expanded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationPreferencesExpanded(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationPreferenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationPreferencesExpanded(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotificationPreferencesExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all notification types with their category and effective mandatory state.
         * @summary Get Notification Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotificationTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Notifications
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortDir] 
         * @param {NotificationStatus | null} [status] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(page?: number, size?: number, sortBy?: string | null, sortDir?: string | null, status?: NotificationStatus | null, name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResultNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(page, size, sortBy, sortDir, status, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List notification delivery channels and their enabled state for the caller\'s organization.
         * @summary Get Supported Notification Channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedChannels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationChannelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedChannels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getSupportedChannels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a single notification.
         * @summary Update Notification
         * @param {string} notificationId 
         * @param {NotificationUpdate} notificationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotification(notificationId: string, notificationUpdate: NotificationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotification(notificationId, notificationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set whether a single notification type is mandatory (platform super-admin action).
         * @summary Update Notification Type Mandatory Flag
         * @param {string} notificationTypeId 
         * @param {NotificationTypeMandatoryUpdate} notificationTypeMandatoryUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationType(notificationTypeId: string, notificationTypeMandatoryUpdate: NotificationTypeMandatoryUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationType(notificationTypeId, notificationTypeMandatoryUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateNotificationType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable/disable a configurable notification channel for the current user\'s organization.
         * @summary Update Supported Notification Channel
         * @param {NotificationChannel} notificationChannel 
         * @param {UpdateNotificationChannelRequest} updateNotificationChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupportedChannel(notificationChannel: NotificationChannel, updateNotificationChannelRequest: UpdateNotificationChannelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupportedChannel(notificationChannel, updateNotificationChannelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateSupportedChannel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Update notifications in bulk.
         * @summary Bulk Update Notification
         * @param {NotificationsApiBulkUpdateNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateNotification(requestParameters: NotificationsApiBulkUpdateNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateNotification(requestParameters.notificationBulkUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Update Current User Notification Preferences
         * @param {NotificationsApiBulkUpdateNotificationPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateNotificationPreferences(requestParameters: NotificationsApiBulkUpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserNotificationPreferenceResponse>> {
            return localVarFp.bulkUpdateNotificationPreferences(requestParameters.updateNotificationPreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the mandatory flag for several notification types at once (platform super-admin action).  Each entry addresses a catalog row by its id because a tag now maps to several ``(tag, concept)`` rows.
         * @summary Bulk Update Notification Type Mandatory Flags
         * @param {NotificationsApiBulkUpdateNotificationTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateNotificationTypes(requestParameters: NotificationsApiBulkUpdateNotificationTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationTypeResponse>> {
            return localVarFp.bulkUpdateNotificationTypes(requestParameters.updateNotificationTypeMandatoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single notification owned by the current user.
         * @summary Get Notification
         * @param {NotificationsApiGetNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(requestParameters: NotificationsApiGetNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Notification> {
            return localVarFp.getNotification(requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated audit logs of notification-settings changes for the caller\'s organization.
         * @summary Get Notification Settings Logs
         * @param {NotificationsApiGetNotificationLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationLogs(requestParameters: NotificationsApiGetNotificationLogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LogPaginated> {
            return localVarFp.getNotificationLogs(requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Current User Notification Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserNotificationPreferenceResponse>> {
            return localVarFp.getNotificationPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Current User Notification Preferences (Expanded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferencesExpanded(options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationPreferenceResponse>> {
            return localVarFp.getNotificationPreferencesExpanded(options).then((request) => request(axios, basePath));
        },
        /**
         * List all notification types with their category and effective mandatory state.
         * @summary Get Notification Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationTypeResponse>> {
            return localVarFp.getNotificationTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Notifications
         * @param {NotificationsApiGetNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(requestParameters: NotificationsApiGetNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResultNotification> {
            return localVarFp.getNotifications(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortDir, requestParameters.status, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * List notification delivery channels and their enabled state for the caller\'s organization.
         * @summary Get Supported Notification Channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedChannels(options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationChannelResponse>> {
            return localVarFp.getSupportedChannels(options).then((request) => request(axios, basePath));
        },
        /**
         * Update a single notification.
         * @summary Update Notification
         * @param {NotificationsApiUpdateNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification(requestParameters: NotificationsApiUpdateNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Notification> {
            return localVarFp.updateNotification(requestParameters.notificationId, requestParameters.notificationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Set whether a single notification type is mandatory (platform super-admin action).
         * @summary Update Notification Type Mandatory Flag
         * @param {NotificationsApiUpdateNotificationTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationType(requestParameters: NotificationsApiUpdateNotificationTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationTypeResponse> {
            return localVarFp.updateNotificationType(requestParameters.notificationTypeId, requestParameters.notificationTypeMandatoryUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable/disable a configurable notification channel for the current user\'s organization.
         * @summary Update Supported Notification Channel
         * @param {NotificationsApiUpdateSupportedChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportedChannel(requestParameters: NotificationsApiUpdateSupportedChannelRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationChannelResponse> {
            return localVarFp.updateSupportedChannel(requestParameters.notificationChannel, requestParameters.updateNotificationChannelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkUpdateNotification operation in NotificationsApi.
 */
export interface NotificationsApiBulkUpdateNotificationRequest {
    readonly notificationBulkUpdate: NotificationBulkUpdate
}

/**
 * Request parameters for bulkUpdateNotificationPreferences operation in NotificationsApi.
 */
export interface NotificationsApiBulkUpdateNotificationPreferencesRequest {
    readonly updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest
}

/**
 * Request parameters for bulkUpdateNotificationTypes operation in NotificationsApi.
 */
export interface NotificationsApiBulkUpdateNotificationTypesRequest {
    readonly updateNotificationTypeMandatoryRequest: Array<UpdateNotificationTypeMandatoryRequest>
}

/**
 * Request parameters for getNotification operation in NotificationsApi.
 */
export interface NotificationsApiGetNotificationRequest {
    readonly notificationId: string
}

/**
 * Request parameters for getNotificationLogs operation in NotificationsApi.
 */
export interface NotificationsApiGetNotificationLogsRequest {
    /**
     * Page number
     */
    readonly page?: number

    /**
     * Page size
     */
    readonly size?: number
}

/**
 * Request parameters for getNotifications operation in NotificationsApi.
 */
export interface NotificationsApiGetNotificationsRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: string | null

    readonly sortDir?: string | null

    readonly status?: NotificationStatus | null

    readonly name?: string | null
}

/**
 * Request parameters for updateNotification operation in NotificationsApi.
 */
export interface NotificationsApiUpdateNotificationRequest {
    readonly notificationId: string

    readonly notificationUpdate: NotificationUpdate
}

/**
 * Request parameters for updateNotificationType operation in NotificationsApi.
 */
export interface NotificationsApiUpdateNotificationTypeRequest {
    readonly notificationTypeId: string

    readonly notificationTypeMandatoryUpdate: NotificationTypeMandatoryUpdate
}

/**
 * Request parameters for updateSupportedChannel operation in NotificationsApi.
 */
export interface NotificationsApiUpdateSupportedChannelRequest {
    readonly notificationChannel: NotificationChannel

    readonly updateNotificationChannelRequest: UpdateNotificationChannelRequest
}

/**
 * NotificationsApi - object-oriented interface
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Update notifications in bulk.
     * @summary Bulk Update Notification
     * @param {NotificationsApiBulkUpdateNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateNotification(requestParameters: NotificationsApiBulkUpdateNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).bulkUpdateNotification(requestParameters.notificationBulkUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Update Current User Notification Preferences
     * @param {NotificationsApiBulkUpdateNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateNotificationPreferences(requestParameters: NotificationsApiBulkUpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).bulkUpdateNotificationPreferences(requestParameters.updateNotificationPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the mandatory flag for several notification types at once (platform super-admin action).  Each entry addresses a catalog row by its id because a tag now maps to several ``(tag, concept)`` rows.
     * @summary Bulk Update Notification Type Mandatory Flags
     * @param {NotificationsApiBulkUpdateNotificationTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateNotificationTypes(requestParameters: NotificationsApiBulkUpdateNotificationTypesRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).bulkUpdateNotificationTypes(requestParameters.updateNotificationTypeMandatoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single notification owned by the current user.
     * @summary Get Notification
     * @param {NotificationsApiGetNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotification(requestParameters: NotificationsApiGetNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotification(requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated audit logs of notification-settings changes for the caller\'s organization.
     * @summary Get Notification Settings Logs
     * @param {NotificationsApiGetNotificationLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationLogs(requestParameters: NotificationsApiGetNotificationLogsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationLogs(requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Current User Notification Preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationPreferences(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Current User Notification Preferences (Expanded)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationPreferencesExpanded(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationPreferencesExpanded(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all notification types with their category and effective mandatory state.
     * @summary Get Notification Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationTypes(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Notifications
     * @param {NotificationsApiGetNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotifications(requestParameters: NotificationsApiGetNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortDir, requestParameters.status, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List notification delivery channels and their enabled state for the caller\'s organization.
     * @summary Get Supported Notification Channels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupportedChannels(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getSupportedChannels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a single notification.
     * @summary Update Notification
     * @param {NotificationsApiUpdateNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateNotification(requestParameters: NotificationsApiUpdateNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateNotification(requestParameters.notificationId, requestParameters.notificationUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set whether a single notification type is mandatory (platform super-admin action).
     * @summary Update Notification Type Mandatory Flag
     * @param {NotificationsApiUpdateNotificationTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateNotificationType(requestParameters: NotificationsApiUpdateNotificationTypeRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateNotificationType(requestParameters.notificationTypeId, requestParameters.notificationTypeMandatoryUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable/disable a configurable notification channel for the current user\'s organization.
     * @summary Update Supported Notification Channel
     * @param {NotificationsApiUpdateSupportedChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSupportedChannel(requestParameters: NotificationsApiUpdateSupportedChannelRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateSupportedChannel(requestParameters.notificationChannel, requestParameters.updateNotificationChannelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

